var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-2xl leading-tight"},[_vm._t("default",[_c('div',{staticClass:"w-24 h-6 mt-2 bg-gray-300 rounded animate-pulse"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }